export const getBreakpoint = (breakpoint: string): number => {
    const variableName = `--breakpoint-${breakpoint}`;
    const value = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
    const numericValue = parseInt(value, 10);

    if (isNaN(numericValue)) {
        return 768; //default value md
    }

    return numericValue;
};
